import AuthFooterScreen from "../../../component/layout/authfooter";
import LogoImg from "@/../../public/images/pelorus-logo.svg";
import accesssystem from "@/../../public/images/Access-control-system.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { ValidationCons } from "../../../validation/validationConstant";
import { useFormik } from "formik";
import { showError, showSuccess } from "../../../utils/Common";
import { AppRoute } from "../../../router/routerConstants";
import { useState } from "react";
import {
  verifyResetUserOTPApi,
  resendResetOTP,
} from "../../../service/apis/auth.api";

const EmailverificationScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const [, setLoading] = useState(false);
  const { state } = useLocation();

  const resendOtp = async () => {
    const bodyData = { email: state.email };
    const response = await resendResetOTP(bodyData);
    showSuccess(response?.message);
  };

  const resetVerifyFormik = useFormik({
    initialValues: {
      otp: Array(6).fill(""),
    },
    validationSchema: yup.object({
      otp: yup
        .array()
        .of(
          yup.string().trim().length(1, ValidationCons.OTP_VERIFY) // Each character must be exactly 1 digit
          // .required(ValidationCons.OTP_VERIFY)
        )
        .length(6, ValidationCons.OTP_VERIFY),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      if (values.otp.join("").length < 6) {
        showError(ValidationCons.OTP_VERIFY);
        return;
      }
      try {
        const bodyData = {
          email: state.email,
          otp: values.otp.join(""),
        };
        const response = await verifyResetUserOTPApi(bodyData);

        if (response?.message === "OTP verified successfully") {
          NavigateTo(AppRoute.RESET_PASSWORD, false, bodyData);
          showSuccess(response?.message);
        }
        setLoading(false);
        // showError(response?.message);
      } catch (error: any) {
        setLoading(false);
        showError(error?.message);
      }
    },
  });

  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                <a href="/">
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd pb-0">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={accesssystem} alt="logo"/>
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Verify Your Email</h1>
                  <p>Enter the 6 digit verification code sent to your email.</p>
                  <div className="login-form-area verifyYouraccount-form mt-5">
                    <Form onSubmit={resetVerifyFormik.handleSubmit}>
                      {/* <p>Your code will expire in <span className="verificationcode">00:05</span></p> */}
                      <div className="verifyYouraccount mb-3">
                        {resetVerifyFormik?.values &&
                          resetVerifyFormik?.values?.otp &&
                          resetVerifyFormik?.values?.otp.map(
                            (digit: string, index: number) => (
                              <Form.Group
                                key={index}
                                controlId={`Verify-number${index + 1}`}
                              >
                                <Form.Control
                                  type="text"
                                  placeholder="X"
                                  maxLength={1}
                                  value={digit}
                                  name={`otp[${index}]`}
                                  // onChange={resetVerifyFormik.handleChange}

                                  onChange={(event) => {
                                    const value = event.target.value;
                                    if (/^\d?$/.test(value)) {
                                      // Allow only single digit
                                      resetVerifyFormik.setFieldValue(
                                        `otp[${index}]`,
                                        value
                                      );

                                      // Move focus to the next input
                                      if (
                                        value &&
                                        index <
                                          resetVerifyFormik.values.otp.length -
                                            1
                                      ) {
                                        const nextInput =
                                          document.querySelector<HTMLInputElement>(
                                            `input[name="otp[${index + 1}]"]`
                                          );
                                        nextInput?.focus();
                                      }
                                    }
                                  }}                                  
                                  onPaste={(event) => {
                                    event.preventDefault();
                                    const pastedValue = event.clipboardData
                                      .getData("text")
                                      .trim();
                                    if (/^\d{6}$/.test(pastedValue)) {
                                      pastedValue
                                        .split("")
                                        .forEach((char, idx) => {
                                          if (
                                            idx <
                                            resetVerifyFormik.values.otp
                                              .length
                                          ) {
                                            resetVerifyFormik.setFieldValue(
                                              `otp[${idx}]`,
                                              char
                                            );
                                          }
                                        });

                                      const lastInput =
                                        document.querySelector<HTMLInputElement>(
                                          `input[name="otp[5]"]`
                                        );
                                      lastInput?.focus();
                                    }
                                  }}
                                  onKeyDown={(event) => {
                                    if (
                                      event.key === "Backspace" &&
                                      !digit &&
                                      index > 0
                                    ) {
                                      const prevInput =
                                        document.querySelector<HTMLInputElement>(
                                          `input[name="otp[${index - 1}]"]`
                                        );
                                      prevInput?.focus();
                                    }
                                  }}
                                  onBlur={resetVerifyFormik.handleBlur}
                                />
                              </Form.Group>
                            )
                          )}
                      </div>
                      <div className="btn-holder mt-5">
                        <Button
                          className="btn w-75 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          Verify Now
                        </Button>
                      </div>
                      <div className="register-now mt-3">
                        <p>
                          Didn't receive a code?{" "}
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a onClick={resendOtp}> Resend Code</a>
                        </p>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />
    </>
  );
};
export default EmailverificationScreen;
